// daoud brand — a very occasional, very small wiggle on the header logo. Purely
// ambient: fires on a long, irregularly-randomised timer (not on load, not on any
// interaction), so most visitors browsing normally will never consciously notice it —
// it just makes the page feel quietly alive rather than static.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MIN_DELAY_MS = 45000;
  var MAX_DELAY_MS = 95000;
  var WIGGLE_DURATION_MS = 700;

  function randomDelay() {
    return MIN_DELAY_MS + Math.random() * (MAX_DELAY_MS - MIN_DELAY_MS);
  }

  function wiggle() {
    var logo = document.querySelector('.header-logo');
    if (logo && document.visibilityState === 'visible') {
      logo.classList.add('daoud-logo-wiggle');
      window.setTimeout(function () {
        logo.classList.remove('daoud-logo-wiggle');
      }, WIGGLE_DURATION_MS);
    }
    window.setTimeout(wiggle, randomDelay());
  }

  window.setTimeout(wiggle, randomDelay());
})();
